import type {
  TeamRoleDetails as gqlTeamRoleDetails,
  PermissionOption as gqlPermissionOption,
  Permission as gqlPermission,
  PermissionGroup as gqlPermissionGroup,
} from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

type PermissionOption = {
  label: string;
  value: string;
};

type Permission = {
  icon: string;
  key: string;
  label: string;
  level: string;
  options: PermissionOption[];
};

type PermissionGroup = {
  icon: string;
  key: string;
  label: string;
  permissions: Permission[];
};

export interface TeamRoleDetails {
  id?: number;
  name?: string;
  permissionGroups?: PermissionGroup[];
}

export const getNew = (): TeamRoleDetails => ({});

const permissionOptionFromGql = (gqlPermissionOption: gqlPermissionOption): PermissionOption => ({
  ...(take(gqlPermissionOption, 'label', 'value') as PermissionOption),
});

const PermissionFromGql = (gqlPermission: gqlPermission): Permission => ({
  ...(take(gqlPermission, 'icon', 'key', 'label', 'level') as Permission),
  options: gqlPermission.options ? gqlPermission.options.map(permissionOptionFromGql) : [],
});

const permissionGroupFromGql = (gqlPermissionGroup: gqlPermissionGroup): PermissionGroup => ({
  ...(take(gqlPermissionGroup, 'icon', 'key', 'label') as PermissionGroup),
  permissions: gqlPermissionGroup.permissions ? gqlPermissionGroup.permissions.map(PermissionFromGql) : [],
});

export const fromGql = (gqlTeamRoleDetails: gqlTeamRoleDetails): TeamRoleDetails => ({
  ...(take(gqlTeamRoleDetails, 'id', 'name') as TeamRoleDetails),
  permissionGroups: gqlTeamRoleDetails.permissionGroups
    ? gqlTeamRoleDetails.permissionGroups.map(permissionGroupFromGql)
    : [],
});
